import { Tooltip } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import SendIcon from '@material-ui/icons/Send';
import HistoryIcon from '@material-ui/icons/History';
import format from 'date-fns/format';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { ConfirmationBox } from '../../../components/ConfirmationBox';
import Loading from '../../../components/Loading';
import ProcessFlowModal from '../../../components/ProcessFlowModal';
import { toast } from 'react-toastify';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { convertForRealFormatted } from '../../../utils/convertForRealFormatted';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import * as S from './styles';

const NO_DATA_MESSAGE =
  'Sucessso na execução da solicitação, porém, não existe retorno com os parâmetro(s) solicitado(s).';

export function TableProposals({
    provider,
    setAtualizaAbatimentoDesconto,
    atualizarAbatimentoDesconto,
    selectedAnchor,
    reloadPage,
    updateContent,
    updateInfo,
    setUpdateInfo,
    destinoPagamentoId,
    setIsLoadingAnchor,
    origin,
    title,
    boxPropostas,
    mensagemToolTip,
    mensagemConfirmacao,
    tipo,
    originUpdateInfo,
    updatedAllProposals,
    setUpdateAllProposals
}) {
    const { setMessageData } = useMessageBox();
    const [isLoading, setIsLoading] = useState(true)
    const [proposals, setProposals] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [isSending, setIsSending] = useState(false);
    const [confirmationBox, setConfirmationBox] = useState({
        show: false,
        type: '',
        message: '',
        callback: () => {},
    });
    const [openProcessFlowModal, setOpenProcessFlowModal] = useState(false);
    const [processFlowAntecipacaoId, setProcessFlowAntecipacaoId] = useState(null);
    const [processFlowFornecedorId, setProcessFlowFornecedorId] = useState(null);
    const [processFlowFornecedorNome, setProcessFlowFornecedorNome] = useState('');


    const columns = [
        {
            text: 'Fornecedor',
            dataField: 'fornecedor',
            sort: true,
            formatter: (cell, rowData) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Tooltip placement="top" title={`${cell} - ${rowData.mensagemHint}`}>
                        <span
                            onClick={() => {
                                reloadPage(rowData, origin)
                                setUpdateInfo({
                                    origin: originUpdateInfo,
                                    id: rowData.antecipacaoId,
                                    canUpdate: false,
                                  });
                            }}
                            className="text-left-block pointer"
                            style={{ flex: 1 }}
                        >
                            {cell && cell.length >= 26 ? `${cell.slice(0, 26)}...` : cell}
                        </span>
                    </Tooltip>
                    <Tooltip placement="top" title="Ver Esteira de Processos">
                        <HistoryIcon
                            style={{ 
                                cursor: 'pointer', 
                                color: '#232D64', 
                                fontSize: '18px',
                                padding: '2px'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!rowData.antecipacaoId || rowData.antecipacaoId === 0) {
                                    toast.warning('Esta é uma operação nova e ainda não possui histórico de logs.');
                                    return;
                                }
                                setProcessFlowAntecipacaoId(rowData.antecipacaoId);
                                setProcessFlowFornecedorId(rowData.fornecedorId);
                                setProcessFlowFornecedorNome(rowData.fornecedor || '');
                                setOpenProcessFlowModal(true);
                            }}  
                        />
                    </Tooltip>
                </div>
            ),
        },
        {
            text: 'Valor',
            dataField: 'valorLiquido',
            sort: true,
            formatter: (cell, rowData) => {
                return (
                    <span
            className={`text-right-block ${
                        rowData.temMensagem && 'has-message-proposal-approved'
                        } ${
                        (rowData.boletosEmitidos || '').toLowerCase() === 'emitidos'
                            ? 'color-emitidos'
                            : (rowData.boletosEmitidos || '').toLowerCase() === 'naoemitidos'
                            ? 'color-naoemitidos'
                            : ''
                        }`}
                    >
                        {convertForRealFormatted(cell, 2)}
                    </span>
                );
            },
        },
    ];

    const selectedIds = useMemo(() => {
        return selectedItems.map(item => item.antecipacaoId);
    }, [selectedItems]);

    const handleOnSelect = useCallback((row, isSelect, rowIndex, e) => {
        if (e) {
            e.stopPropagation();
        }
        setSelectedItems(prevSelected => {
            const array = [...prevSelected];
            if (isSelect) {
                // Verifica se já não está selecionado para evitar duplicatas
                const isAlreadySelected = array.some((el) => el.antecipacaoId === row.antecipacaoId);
                if (!isAlreadySelected) {
                    return [...array, {
                        antecipacaoId: row.antecipacaoId,
                        fornecedorId: row.fornecedorId,
                        dataAtualizacao: row.dataAtualizacao,
                        valorLiquido: row.valorLiquido,
                    }];
                }
                return array;
            } else {
                return array.filter((el) => el.antecipacaoId !== row.antecipacaoId);
            }
        });
    }, []);

    const handleOnSelectAll = useCallback((isSelect, rows) => {
        if (isSelect) {
            const newItems = rows.map((row) => ({
                antecipacaoId: row.antecipacaoId,
                fornecedorId: row.fornecedorId,
                dataAtualizacao: row.dataAtualizacao,
                valorLiquido: row.valorLiquido,
            }));
            setSelectedItems(newItems);
        } else {
            setSelectedItems([]);
        }
    }, []);

    const selectRow = useMemo(() => ({
        mode: 'checkbox',
        clickToSelect: false,
        selected: selectedIds,
        onSelect: handleOnSelect,
        onSelectAll: handleOnSelectAll,
    }), [selectedIds, handleOnSelect, handleOnSelectAll]);

    const handleConfirmationBox = (message, callback) => {
        if (selectedItems.length === 0 || isSending) return;
        setConfirmationBox({
            show: true,
            type: '',
            message,
            callback,
        });
    };

    // Quando o box é o Passo5 (terceiros), o texto do ConfirmationBox muda
    // conforme a SituacaoAprovacao cadastrada no destino:
    //   - ContratoAssinadoPeloFornecedor (13)
    //     => usa mensagemConfirmacao que vem do backend (já adaptado para
    //        "Liberar pagamento?" em CarregarConfiguracoesTela).
    //   - EnviadaDestinoPagamento (6)
    //     => 'Pagamento realizado?'.
    //   - null/outro => fallback no HabilitaEnvioRemessa (Sim => remessa, Não => pagamento).
    // Em qualquer outra box, mantém o mensagemConfirmacao da prop.
    const prepareSendConfirmation = useCallback(async () => {
        if (selectedItems.length === 0 || isSending) return;
        if (boxPropostas !== 'BoxTerceirosPasso5ContratoAssinadoPeloFornecedor') {
            handleConfirmationBox(mensagemConfirmacao, sendApprove);
            return;
        }
        let mensagemAdaptada = mensagemConfirmacao;
        try {
            const resp = await api.get(`DestinosPagamentos/ConsultarId?id=${destinoPagamentoId}`);
            const destino = resp?.data?.resposta;
            // API serializa enums como string via JsonStringEnumConverter.
            const situacaoAprovacao = destino?.situacaoAprovacao ?? destino?.SituacaoAprovacao;
            if (situacaoAprovacao === 'ContratoAssinadoPeloFornecedor') {
                // Backend já mandou o texto adaptado ("Liberar pagamento?").
                mensagemAdaptada = mensagemConfirmacao;
            } else if (situacaoAprovacao === 'EnviadaDestinoPagamento') {
                mensagemAdaptada = 'Pagamento realizado?';
            } else {
                // Fallback: cai no HabilitaEnvioRemessa (Sim => remessa, Não => pagamento).
                const habilitaRemessa = Number(destino?.habilitaEnvioRemessa ?? destino?.HabilitaEnvioRemessa) === 1;
                mensagemAdaptada = habilitaRemessa
                    ? 'Enviar para remessa?'
                    : 'Pagamento realizado?';
            }
        } catch (_) {
            // Falha de leitura do destino: cai pra mensagem padrão (não bloqueia o fluxo).
        }
        handleConfirmationBox(mensagemAdaptada, sendApprove);
    }, [selectedItems, isSending, boxPropostas, destinoPagamentoId, mensagemConfirmacao]);

    const fetchProposals = async () => {
        setIsLoading(true);
        setIsLoadingAnchor(true)
        setSelectedItems([]);
        try {
            const currentDay = format(new Date(), 'yyyy-MM-dd');
            const response = await api.get(
                `OperacoesAntecipacoes/ConsultarAntecipacoesPorStatus?ancoraId=${selectedAnchor?.ancoraId}&boxPropostas=${boxPropostas}&dataAntecipacao=${currentDay}&destinoPagamentoId=${destinoPagamentoId.toString()}`,
            );
            if (response.data.status !== 'Inconsistencia') {
                setMessageData(response?.data?.complemento?.mensagensBox);
                if (response.data.resposta[0].message !== NO_DATA_MESSAGE) {
                    setProposals(response.data.resposta);
                } else {
                    setProposals([]);
                    setMessageData(response?.data?.complemento?.mensagensBox);
                }
            } else {
                handleErrorRequest(response);
                setMessageData(response?.data?.complemento?.mensagensBox);
            }
        } catch (error) {
            setMessageData(error?.response?.data?.complemento?.mensagensBox);
            handleErrorRequest(error.response);
        } finally {
            setUpdateAllProposals(false)
            setIsLoading(false);
            setIsLoadingAnchor(false)
            if(boxPropostas == 'BoxPropostasAprovadas' || boxPropostas == 'BoxTerceiroAguardandoAprovacaoRede') {
                setAtualizaAbatimentoDesconto(false)
            }
        }
    };

    const sendApprove = async () => {
        setIsSending(true);
        try {
            const bodyRequest = {
                ancoraId: selectedAnchor?.ancoraId,
                antecipacoes: selectedItems,
                boxPropostas: boxPropostas,
                destinoPagamentoId: destinoPagamentoId
            };

            const response = await api.put(
                'OperacoesAntecipacoes/EnviarBoxPropostas',
                bodyRequest,
            );
            if (response.data.status !== 'Inconsistencia') {
                setMessageData(response?.data?.complemento?.mensagensBox);
                setUpdateAllProposals(true)
            } else {
                handleErrorRequest(response);
                setMessageData(response?.data?.complemento?.mensagensBox);
            }
        } catch (error) {
            handleErrorRequest(error.response);
            setMessageData(error?.response?.data?.complemento?.mensagensBox);
        } finally {
            setSelectedItems([]);
            setIsSending(false);
        }
    };


    useEffect(() => {
        fetchProposals();
    }, [provider, selectedAnchor, updateContent]);

    useEffect(() => {
        if(updatedAllProposals) {
            fetchProposals();
        }
    }, [updatedAllProposals]);

    useEffect(() => {
        if(atualizarAbatimentoDesconto) {
            fetchProposals();
        }
    }, [atualizarAbatimentoDesconto]);
  

    useEffect(() => {
        if (updateInfo.canUpdate) {
            if (updateInfo.origin.toLowerCase() === originUpdateInfo.toLowerCase()) {
                const newOptions = proposals.filter((item) => item.antecipacaoId !== updateInfo.id);
                setProposals(newOptions);
                setIsLoading(true);
                setTimeout(() => {
                    setIsLoading(false);
                    setUpdateInfo({ origin: '', id: null, canUpdate: false });
                }, 100);
                return;
            }
            if (localStorage.getItem('isReplace') != null) {
                if (localStorage.getItem('isReplace') && localStorage.getItem('isReplace').toLowerCase() === originUpdateInfo.toLowerCase()) {
                const newOptions = proposals.filter((item) => item.antecipacaoId !== updateInfo.id);
                setProposals(newOptions);
                setTimeout(() => {
                    setUpdateInfo({ origin: '', id: null, canUpdate: false });
                    localStorage.setItem('isReplace', '');
                }, 100);}
            }
        }
    }, [updateInfo]);

    useEffect(() => {
        // Garantir que os checkboxes sejam clicáveis após a renderização
        if (!proposals || proposals.length === 0) return;
        
        const enableCheckboxes = () => {
            // Buscar checkboxes em todas as tabelas, não apenas .approved-table
            const checkboxes = document.querySelectorAll('.selection-cell input[type="checkbox"], .selection-cell-header input[type="checkbox"]');
            const selectionCells = document.querySelectorAll('.selection-cell, .selection-cell-header');
            
            checkboxes.forEach((checkbox) => {
                checkbox.style.pointerEvents = 'auto';
                checkbox.style.cursor = 'pointer';
                checkbox.style.zIndex = '999';
                checkbox.style.position = 'relative';
                checkbox.setAttribute('tabindex', '0');
            });
            
            selectionCells.forEach((cell) => {
                cell.style.pointerEvents = 'auto';
                cell.style.zIndex = '999';
                cell.style.position = 'relative';
            });
        };
        
        // Executar após a renderização
        const timeoutId = setTimeout(enableCheckboxes, 300);
        
        // Observar mudanças na tabela - buscar em qualquer container de tabela
        const observer = new MutationObserver(() => {
            setTimeout(enableCheckboxes, 150);
        });
        
        // Buscar o container da tabela atual
        const tableContainer = document.querySelector('.react-bootstrap-table') || 
                               document.querySelector('.approved-table') ||
                               document.querySelector('.lateral-table');
        if (tableContainer) {
            observer.observe(tableContainer, { childList: true, subtree: true });
        }
        
        return () => {
            clearTimeout(timeoutId);
            observer.disconnect();
        };
    }, [proposals]);

    if (isLoading || isSending) {
        return (
            <>
                <S.TableTitleHeader>
                    <h3 className="operation-title">{title}</h3>
                    </S.TableTitleHeader>
                <Loading />
            </>
        );
    }

    const rowStyle = (row) => {
        const style = {}

        if(row.corFonte) {
        style.color = row.corFonte
        }

        if (row.corFundo) {
        style.backgroundColor = row.corFundo
        }

        return style
    }

    return (
        <>
            {proposals.length > 0 && (
                <S.TableContent>
                    <S.TableTitleHeader>
                        <h3 className="operation-title">{title}</h3>
                        {tipo == 'Envio' ? (
                            <div className="operation-actions">
                                <Tooltip placement="top" title={mensagemToolTip}>
                                    <SendIcon
                                    disabled={isSending}
                                    className="pointer"
                                    onClick={() => prepareSendConfirmation()}
                                    />
                                </Tooltip>
                                <Tooltip placement="top" title="Recarregar conteúdo">
                                    <CachedIcon className="pointer" onClick={() => fetchProposals()} />
                                </Tooltip>
                            </div>
                        ) : (
                            <Tooltip placement="top" title="Recarregar conteúdo">
                                <CachedIcon className="pointer" onClick={() => fetchProposals()} />
                            </Tooltip>
                        )}
                    </S.TableTitleHeader>
                    <S.ScrollTable className={tipo == 'Envio' ? "approved-table" : "lateral-table"}>
                        {tipo == 'Envio' ? (
                            <BootstrapTable
                                columns={columns}
                                data={proposals}
                                keyField="antecipacaoId"
                                striped
                                hover
                                condensed
                                selectRow={selectRow}
                                cellEdit={cellEditFactory}
                                rowStyle={rowStyle}
                            />
                        ) : (
                            <BootstrapTable
                                columns={columns}
                                data={proposals}
                                keyField="antecipacaoId"
                                // rowEvents={tableRowEvents} clique na linha
                                striped
                                hover
                                condensed
                                rowStyle={rowStyle}
                            />
                        )}
                    </S.ScrollTable>
                </S.TableContent>
            )}
            {confirmationBox.show && (
                <ConfirmationBox
                    data={confirmationBox}
                    setConfirmationBox={setConfirmationBox}
                ></ConfirmationBox>
            )}
            
            {/* Modal de Esteira de Processos */}
            <ProcessFlowModal
                open={openProcessFlowModal}
                onClose={() => setOpenProcessFlowModal(false)}
                antecipacaoId={processFlowAntecipacaoId}
                fornecedorId={processFlowFornecedorId}
                fornecedorNome={processFlowFornecedorNome}
            />
        </>
    );
}
